/**
 * Core Information section — item identification + manufacturer +
 * description/purpose/scope. Pulls from `formatted.core_information`.
 *
 * Always renders all SubSections (matches legacy
 * CompleteItemDefinition behavior). Empty leaves fall back to "—".
 */
import React from 'react';
import { SectionCard, SubSection, Field, StringListField, type SectionProps } from './parts';

const PATH = ['core_information'];

export default function CoreInformation({ data, isEditing, onChange }: SectionProps) {
  const core = data ?? {};
  const manufacturer = core.manufacturer ?? {};
  const scope = core.scope ?? {};

  return (
    <SectionCard title="Core Information" id="core_information">
      <SubSection title="Item identification">
        <Field label="Item name" value={core.item_name} isEditing={isEditing} onChange={onChange} path={[...PATH, 'item_name']} />
        <Field label="Item category" value={core.item_category} isEditing={isEditing} onChange={onChange} path={[...PATH, 'item_category']} />
        <Field label="Item version" value={core.item_version} isEditing={isEditing} onChange={onChange} path={[...PATH, 'item_version']} />
        <Field label="Development status" value={core.development_status} isEditing={isEditing} onChange={onChange} path={[...PATH, 'development_status']} />
        <Field label="Vehicle platform" value={core.vehicle_platform} isEditing={isEditing} onChange={onChange} path={[...PATH, 'vehicle_platform']} />
        <Field label="Model year" value={core.model_year} isEditing={isEditing} onChange={onChange} path={[...PATH, 'model_year']} />
        <Field label="Production date range" value={core.production_date_range} isEditing={isEditing} onChange={onChange} path={[...PATH, 'production_date_range']} />
      </SubSection>

      <SubSection title="Manufacturer">
        <Field label="Name" value={manufacturer.name} isEditing={isEditing} onChange={onChange} path={[...PATH, 'manufacturer', 'name']} />
        <Field label="Location" value={manufacturer.location} isEditing={isEditing} onChange={onChange} path={[...PATH, 'manufacturer', 'location']} />
        <Field label="OEM" value={manufacturer.oem} isEditing={isEditing} onChange={onChange} path={[...PATH, 'manufacturer', 'oem']} />
      </SubSection>

      <SubSection title="Description & purpose">
        <Field label="Description" value={core.description} isEditing={isEditing} onChange={onChange} path={[...PATH, 'description']} multiline />
        <Field label="Purpose" value={core.purpose} isEditing={isEditing} onChange={onChange} path={[...PATH, 'purpose']} multiline />
      </SubSection>

      <SubSection title="Scope">
        <Field label="Definition" value={scope.definition} isEditing={isEditing} onChange={onChange} path={[...PATH, 'scope', 'definition']} multiline />
        <Field label="Rationale" value={scope.rationale} isEditing={isEditing} onChange={onChange} path={[...PATH, 'scope', 'rationale']} multiline />
        <StringListField label="In-scope items" items={scope.in_scope_items} isEditing={isEditing} onChange={onChange} path={[...PATH, 'scope', 'in_scope_items']} />
        <StringListField label="Out-of-scope items" items={scope.out_of_scope_items} isEditing={isEditing} onChange={onChange} path={[...PATH, 'scope', 'out_of_scope_items']} />
        <StringListField label="Limitations" items={scope.limitations} isEditing={isEditing} onChange={onChange} path={[...PATH, 'scope', 'limitations']} />
      </SubSection>
    </SectionCard>
  );
}
